import { Card, CardBody, Chip } from '@heroui/react';
import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

export const SubCatalogSelect: React.FC = () => {
  return (
    <div className="space-y-4">
      <Card className="border-warning-200 bg-warning-50">
        <CardBody>
          <div className="flex items-start gap-3">
            <FiAlertTriangle className="w-5 h-5 text-warning-600 mt-0.5 flex-shrink-0" />
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <Chip color="warning" variant="flat" size="sm">
                  LOX Migration
                </Chip>
              </div>
              <p className="text-warning-800 font-medium">
                This distributor has been migrated to LOX.
              </p>
              <p className="text-warning-700 text-sm">
                Please use the available Retool app for managing the custom
                catalogs for this supplier.
              </p>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
